import React from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Link,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import { FaLinkedin } from 'react-icons/fa';

// eslint-disable-next-line arrow-body-style
const TheContextBudgetBlog = () => {
  return (
    <>
      {/* members */}
      <Flex
        as="section"
        flexDirection="column"
        overflow="hidden"
        justify="center"
        height={{ xs: '450px', sm: '300px' }}
        minH={{ xs: '450px', sm: '300px' }}
        maxH="450px"
        pos="relative"
      >
        <Img
          pos="absolute"
          objectFit="cover"
          src="/jpg/blogBanner.jpg"
          alt="members-hero"
          height="100%"
          width="100%"
        />
        <Box
          bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
          pos="absolute"
          height="100%"
          width="100%"
          opacity="0.7"
        />
        <Container
          display="flex"
          as="section"
          maxW="container.xl"
          position="relative"
          zIndex="1"
          flexDirection="column"
        >
          <Flex
            alignItems={{ xs: 'flex-start', md: 'flex-start' }}
            justifyContent="center"
            columnGap="24px"
            justifyItems="center"
            width="100%"
            display="flex"
            as="section"
            rowGap="30px"
            flexDir={{
              xs: 'column',
              md: 'row',
            }}
          >
            <Flex flexDir="column" rowGap="16px">
              <Heading
                color="white"
                fontSize={{ xs: '36px', sm: '42px', lg: '64px' }}
                fontWeight="800"
                lineHeight={{ xs: '35px', lg: '83px' }}
              >
                #TheContext
              </Heading>
            </Flex>
            <Box
              w="1.5px"
              h={{ xs: '100%' }}
              bgColor="white"
              display={{ xs: 'none', md: 'block' }}
            />
            <Box
              w={{ xs: '70%', sm: '60%' }}
              h="1.5px"
              bgColor="white"
              display={{ xs: 'block', md: 'none' }}
            />
            {/*  */}
            <Heading
              as="h1"
              mb={{ xs: '10px', md: '20px' }}
              variant="reportCardTitle"
              fontSize={{ xs: '27px', sm: '29px', md: '32px', lg: '38px' }}
              color="white"
              lineHeight={{ xs: '36px', sm: '40px', md: '46px', lg: '62px' }}
            >
              Budget 2025: Paving the Way for an Equitable and Prosperous India
            </Heading>
          </Flex>
        </Container>
      </Flex>
      <Container
        as="section"
        maxW="container.xl"
        pb="80px"
        pt="40px"
        minH="420px"
        display={{ xs: 'flex', md: 'inherit' }}
        flexDirection="column"
      >
        <Box
          float={{ xs: 'right', md: 'left' }}
          alignSelf={{ xs: 'center', md: 'flex-start' }}
          mx={{ xs: '0px', md: '0px' }}
          mr={{ xs: '0px', md: '40px', lg: '60px', xl: '40px' }}
          mb="20px"
        >
          <Flex
            flexDir={{
              xs: 'column',
              md: 'row',
            }}
            gap="20px"
            alignItems={{
              xs: 'center',
              md: 'unset',
            }}
          >
            <Img
              src="https://static.levocdn.com/WGLBUT82/WhatsAppImage2025-02-01at52146PM-tryCJ0OIkI7X.jpeg"
              alt="Rajat Tandon
"
              width="250px"
              height="250px"
              objectFit="cover"
              borderRadius="50%"
            />
            <Flex direction="column">
              <Heading
                as="h1"
                fontWeight="800"
                pt="20px"
                variant="reportCardTitle"
                fontSize={{ xs: '16px', md: '18px', lg: '20px' }}
                textAlign={{
                  xs: 'center',
                  md: 'left',
                }}
              >
                Rajat Tandon
                <Link
                  href="https://www.linkedin.com/in/rajat-tandon-india/"
                  target="_blank"
                  display={{ xs: 'inline-block', md: 'none' }}
                  pl="10px"
                >
                  <IconButton
                    aria-label="linkedin"
                    icon={<FaLinkedin size="28px" color="#067acc" />}
                    variant="unstyled"
                    cursor="pointer"
                  />
                </Link>
              </Heading>
              <Text
                color="text.mediumBlack"
                maxW={{
                  xs: '100%',
                  md: '120px',
                }}
                w="100%"
                fontSize="16px"
                lineHeight="22px"
                fontStyle="italic"
                textAlign={{
                  xs: 'center',
                  md: 'left',
                }}
              >
                President, IVCA
              </Text>

              <Link
                href="https://www.linkedin.com/in/rajat-tandon-india/"
                target="_blank"
                display={{
                  xs: 'none',
                  md: 'block',
                }}
              >
                <IconButton
                  aria-label="linkedin"
                  icon={<FaLinkedin size="28px" color="#067acc" />}
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Flex>
          </Flex>
        </Box>
        <Box>
          <Box mt="16px" mb="20px">
            <Text variant="blogAnswer">
              Honourable Union Minister of Finance Nirmala Sitharaman has set a
              new benchmark by presenting her eighth consecutive budget, making
              her the longest-serving Finance Minister in India. Focused on the
              vision of Viksit Bharat, this budget outlines key reforms across
              six critical areas: Taxation, Power sector, Urban development,
              Mining, Financial sector and Regulatory reforms. <br />
              This year’s Union Budget takes a strategic approach to balancing
              growth, innovation, and sustainability. IVCA applauds the
              Government’s continued efforts to foster a strong investment
              ecosystem, strengthen India’s financial and entrepreneurial
              landscape, and drive long-term economic progress.
            </Text>
          </Box>
          {/* 1 */}
          <Box my="40px">
            <Text variant="blogAnswer" fontWeight="800">
              IVCA expresses its sincere appreciation for the following
              announcements:
            </Text>
          </Box>

          {/* 3  */}
          <Box my="16px">
            <Box>
              <UnorderedList>
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    <strong> New Income Tax Bill</strong>: The finance minister
                    announced that the new income tax bill will be introduced
                    next week. Its objective is to simplify the tax system,
                    improving clarity for taxpayers and tax administrators while
                    reducing litigation. This reform aims to enhance efficiency,
                    ensure greater compliance, and provide a more transparent
                    framework for all stakeholders.
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    <strong>Strengthening Financial Regulations</strong>: Under
                    the Financial Stability and Development Council (FSDC), a
                    mechanism will be put in place to evaluate the impact of
                    current financial regulations and subsidiary instructions.
                    This move will also draw up a framework to enhance their
                    responsiveness, ensuring that the financial sector keeps up
                    with the times. The initiative is a step in the right
                    direction to ensure regulations are not only fit for purpose
                    but also agile enough to support sector growth, thus paving
                    the way towards ease of doing business.
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    <strong>A New Fund of Funds for Startups</strong> : The
                    startup ecosystem has seen a sizeable commitment of over
                    ₹91,000 crore through AIFs. These funds have been backed by
                    the Fund of Funds initiative, which started with a
                    government contribution of ₹10,000 crore. With the sector
                    showing tremendous promise, the Government is now taking a
                    significant step forward by setting up a new Fund of Funds.
                    This new fund, with an expanded scope and an additional
                    ₹10,000 crore in funding, will go a long way in further
                    strengthening support for startups and spurring innovation
                    in India.
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    <strong>A Deep Tech Fund of Funds</strong>: Following up
                    from the above point, as part of the Government's commitment
                    to fostering innovation, a Deep Tech Fund of Funds will be
                    considered to accelerate the growth of next-generation
                    startups. This initiative aims to support advanced
                    technologies and nurture the development of India’s
                    deep-tech sector. It’s a great recognition to the
                    credibility of Fund of Funds for Startups (FFS) Scheme and
                    its impact by supporting 140 plus AIF fund managers who are
                    investing into startups and growth entrepreneurs driving job
                    creation at scale.
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    <strong>
                      Enhanced Credit Guarantee Cover for Startups
                    </strong>{' '}
                    : The government has increased the credit guarantee cover
                    from ₹10 crore to ₹20 crore, while also reducing the
                    guaranteed fee to 1 per cent. This strategic move ensures
                    that key industries receive the essential financial support
                    needed to flourish, thereby leading to national growth and
                    advancing the goal of self-reliance.
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    <strong>
                      Extension of Time Limit under Section 80-IAC for Startups
                    </strong>
                    : The proposal to extend the time limit under Section 80-IAC
                    for startups is a commendable move, further enhancing the
                    ease of doing business in India. By extending the benefit
                    for another five years, until 01.04.2030, the Government is
                    providing crucial support to eligible startups, encouraging
                    innovation and fostering long-term growth in the
                    entrepreneurial ecosystem. This extension will help startups
                    access vital financial benefits, thereby strengthening their
                    ability to scale and succeed in a competitive market.
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    <strong>
                      Parity in Long-Term Capital Gains Tax for Residents and
                      Non-Residents
                    </strong>
                    : The proposal to bring parity in the rates of long-term
                    capital gains tax on the transfer of securities by
                    non-residents, including Foreign Institutional Investors
                    (FIIs), is a welcome move. By aligning the tax treatment for
                    both residents and non-residents, the Government is
                    promoting fairness and attracting foreign investment. This
                    step will simplify the taxation process and encourage
                    greater participation from global investors in India’s
                    securities market, thereby fostering growth and stability in
                    the financial ecosystem.
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    <strong>
                      Proposed Amendment to 'Capital Asset' Definition Enhances
                      Tax Clarity for Investment Funds
                    </strong>
                    : The proposed amendment to the definition of 'capital
                    asset' is a commendable step in bringing much-needed clarity
                    to the taxation of income arising from the transfer of
                    securities held by investment funds, as outlined in Section
                    115UB of the Act. By refining the chargeability of such
                    income, this change enhances transparency and ensures a more
                    precise understanding of tax obligations. This initiative
                    will not only simplify the tax compliance process for
                    investment funds but also contribute to a more predictable
                    and efficient regulatory environment, fostering greater
                    confidence and growth in India’s investment landscape.
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    <strong>
                      SWAMIH Fund 2 to Accelerate Affordable Housing with
                      ₹15,000 Crore Investment
                    </strong>
                    : The establishment of SWAMIH Fund 2 marks a significant
                    milestone in addressing the housing needs of middle-class
                    families. Building on the success of the first fund, which
                    has already facilitated the completion of 50,000 dwelling
                    units, the new ₹15,000 crore fund aims to accelerate the
                    completion of an additional 1 lakh units. The collaborative
                    approach, involving contributions from the Government,
                    banks, and private investors, is a forward-thinking strategy
                    that will drive swift progress and bring much-needed relief
                    to homebuyers. This initiative is set to further strengthen
                    the housing sector and support the growth of affordable
                    housing in India.
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    <strong>
                      Tax Certainty for AIFs and Extension of Investment
                      Deadline for Sovereign and Pension Funds
                    </strong>
                    : The finance minister also stated that Category I and II
                    Alternate Investment Funds (AIFs), which are investing in
                    infrastructure and other priority sectors, will benefit from
                    certainty in taxation on gains from securities.
                    Additionally, to further promote investment from Sovereign
                    Wealth Funds and Pension Funds in the infrastructure sector,
                    she proposed extending the deadline for making investments
                    by five more years, until 31st March 2030. These steps are
                    aimed at encouraging sustained financial inflows into
                    critical sectors.
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    <strong>
                      FDI Limit in Insurance Sector Raised to 100%, Boosting
                      Foreign Investment and Sector Growth
                    </strong>{' '}
                    : Under the financial sector reforms and development, the
                    FDI limit for the insurance sector will be raised from 74%
                    to 100%. This enhanced limit will apply to companies that
                    invest the entire premium in India. Furthermore, the current
                    guardrails and conditionalities associated with foreign
                    investment in the sector will be reviewed and simplified,
                    facilitating easier engagement for foreign players in
                    India’s insurance market. This move is expected to attract
                    more foreign capital, foster healthy competition, and
                    accelerate the growth of the sector.
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    <strong>
                      Streamlined Safe Harbour Regime and Extended Relaxation
                      for IFSC Units
                    </strong>
                    : The proposal to introduce a simplified safe harbour regime
                    for investment funds managed by fund managers based in the
                    International Financial Services Centre (IFSC) is a highly
                    positive development. It will significantly ease regulatory
                    requirements, creating a more attractive and efficient
                    environment for fund managers, and further strengthening
                    IFSC as a global financial hub. The extension of the
                    relaxation of conditions for IFSC units until 31st March
                    2030 is another encouraging step. This forward-looking
                    measure will offer greater stability, fostering long-term
                    growth and encouraging further investment in the IFSC.
                    Additionally, tax exemptions on life insurance policies
                    issued by IFSC insurance offices are expected to attract
                    more insurers catering to NRI markets, while capital gains
                    and dividend exemptions for ship leasing units will pave the
                    way for IFSC to emerge as a ship leasing hub, similar to its
                    success in aircraft leasing.
                    <br />
                    Further, rationalizing the definition of ‘dividend’ for
                    treasury centres and introducing a simplified tax regime for
                    fund managers will encourage multinational corporations and
                    global fund houses to base their treasury and investment
                    operations in IFSC, creating new jobs and deepening India’s
                    financial ecosystem. Amendments to Section 10, providing tax
                    exemptions for non-residents, will boost derivatives and
                    offshore investment products from IFSC, aligning with the
                    government's vision of “onshoring the offshore.” The
                    inclusion of retail schemes and ETFs in the fund relocation
                    framework, along with reduced withholding tax rates for
                    private credit funds, will enhance IFSC’s attractiveness for
                    global asset managers. Together, these measures offer a
                    robust roadmap for IFSC’s expansion, driving its evolution
                    into a premier international financial hub.
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    <strong>
                      Overhaul of Bilateral Investment Treaty Model to Boost
                      Global Investment
                    </strong>{' '}
                    : The government's decision to revamp the Bilateral
                    Investment Treaty model is a praiseworthy and
                    forward-thinking initiative. By making the model more
                    ‘investment-friendly,’ it is set to expedite the conclusion
                    of protracted bilateral investment agreements with partner
                    countries. The emphasis on this reform demonstrates a strong
                    commitment to enhancing India’s investment landscape and
                    strengthening its economic ties globally.
                  </Text>
                </ListItem>
                <br />
              </UnorderedList>
            </Box>
          </Box>
        </Box>

        <Box width="100%" height="2px" bgColor="primary.200" />
        <Text
          variant="blogAnswer"
          lineHeight="30px"
          pt="18px"
          fontStyle="italic"
          p="12px 12px 0px"
          fontWeight="500"
        >
          <Text as="span" fontWeight="700" fontStyle="normal">
            #TheContext by IVCA
          </Text>{' '}
          – features opinion makers from the alternate investing industry with
          strong focus on India as an investment destination. Watch this space
          for new announcements in the sector, viewpoints on investment themes,
          emerging trends, economic reports, analysis and latest industry
          insights.
        </Text>
        <Heading
          variant="blogQuestion"
          lineHeight="30px"
          pt="16px"
          fontStyle="italic"
          p="12px 12px 0px"
        >
          Content in this section is curated by team IVCA. To share feedback,
          connect with&nbsp;
          {/* The content in this section is curated by Team IVCA. For any feedback,
          connect with&nbsp; */}
          <Link
            href="mailto:paromita.sinha@ivca.in"
            target="_blank"
            style={{ color: 'blue', textDecoration: 'underline' }}
          >
            paromita.sinha@ivca.in
          </Link>
        </Heading>
      </Container>
    </>
  );
};

export default TheContextBudgetBlog;
